import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueMeta from 'vue-meta'
import VueI18n from 'vue-i18n'
import i18nEnUs from './translations/en_US'
import i18nZhCn from './translations/zh_CN'
import ElementUI from 'element-ui'
import localEnUs from 'element-ui/lib/locale/lang/en'
import localeZhCn from 'element-ui/lib/locale/lang/zh-CN'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(VueMeta)
Vue.use(VueI18n)
const messages = {
  en_US: {
    ...i18nEnUs,
    ...localEnUs
  },
  zh_CN: {
    ...i18nZhCn,
    ...localeZhCn
  }
}
const i18n = new VueI18n({
  locale: 'zh_CN',
  messages
})

Vue.config.productionTip = false
Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value), size: 'small' })

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
